import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=e54ebc20&"
import script from "./AccountView.vue?vue&type=script&lang=js&"
export * from "./AccountView.vue?vue&type=script&lang=js&"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=e54ebc20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports